import axios from "axios";
import {PopupMessage} from "../utils/message";

interface SettingsItem {
    key: string;
    value: string;
    type: string;
}

export class Config {
    private static _instance: Config;
    apiUrl: string;
    chatServerAddress: string;
    devApiUrl: string;
    environment: string;
    config: any;
    settings: SettingsItem[];

    async fetchConfiguration() {
        try {
            const response = await axios.get(`${this.getApiUrl()}/api/config`);
            this.environment = response.data.environment;
            this.config = response.data;

            this.settings = response.data.settings.map(item => ({
                ...item,
                value: this.parseSettingsValue(item)
            }));

            this.setChatServerAddress();
            this.getDevApiUrl();
        } catch (_) {
            PopupMessage.error("Failed to load configuration from the API");
        }
    }

    parseSettingsValue(item) {
        switch (item.type) {
            case "boolean":
                return item.value.toLowerCase() === "true";
            case "number":
                return parseInt(item.value, 10);
            case "json":
                return JSON.parse(item.value);
            default:
                return item.value;
        }
    }

    getSettingByKey(key: string, defaultValue = null) {
        return this.settings?.find(item => item.key === key)?.value || defaultValue;
    }

    getApiUrl(): string {
        const host = process.env.HOST;
        const port = process.env.PORT;

        if (!!host && !!port) {
            /**
             * Backend bind host may be 0.0.0.0 in Docker/local.
             * Browsers cannot request 0.0.0.0, so reuse current browser hostname.
             */
            const normalizedHost = host === "0.0.0.0" ? window.location.hostname : host;
            this.apiUrl = `http://${normalizedHost}:${port}`;
            return this.apiUrl;
        }

        this.apiUrl = window.location.origin;
        return this.apiUrl;
    }

    getDevApiUrl() {
        let url = process.env.DEV_HOST;

        if(!!process.env.DEV_PORT) {
            url += `:${process.env.DEV_PORT}`;
        }
        
        const protocol = process.env.DEV_PROTOCOL || "http";

        this.devApiUrl = `${protocol}://${url}`;
        console.log("getDevApiUrl: " + this.devApiUrl);
        this.devApiUrl = "https://staging-console.gammasmilefeminine8.xyz";

    }

    setChatServerAddress() {
        const address = process.env.CHAT_SERVER_ADDRESS;
        let port = process.env.CHAT_SERVER_PORT || "";
        port = port ? port.trim() : port;

        // If port is provided, the url will be http://address:port
        // If not, the url will be http://address
        // Check if port is number, because it can be " " or ""

        const url = (!port || isNaN(Number(port))) ? `http://${address}` : `http://${address}:${port}`;

        this.chatServerAddress = url;
    }

    static get getInstance() {
        return this._instance || (this._instance = new this());
    }
}
